/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  minWidth: 100,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

function Table2({ setFieldValue }) {
  const [data, setData] = useState({
    factory: [
      {
        id: uuidV4(),
        value2: "Nhà máy",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
        value7: "",
        value8: "",
        value9: 0,
        value10: "0.00",
        value11: 0,
      },
    ],
    muc1: [
      {
        id: uuidV4(),
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
        value7: "",
        value8: "",
        value9: 0,
        value10: "0.00",
        value11: 0,
      },
    ],
  });

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value, id, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleChangeValue = (type, id, name, value) => {
    setData((prev) => ({
      ...prev,
      [type]: prev[type]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleAdd = (type) => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: 0,
      value10: "0.00",
      value11: 0,
    };
    setData((prev) => ({ ...prev, [type]: [...prev[type], newRow] }));
  };

  const handleDelete = (type, id) => {
    setData((prev) => ({ ...prev, [type]: prev[type].filter((item) => item.id !== id) }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box style={{ maxWidth: "100%" }}>
        <table style={tableStyle}>
          <tbody>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                STT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Loại chỉ tiêu
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Chỉ tiêu
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Mã số thuế/ Mã địa diểm kinh doanh
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                Địa bàn hoạt động sản xuất, kinh doanh
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                Cơ quan thuế quản lý địa bàn nhận phân bổ
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Số thuế GTGT phải nộp của nhà máy thuỷ điện
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Tỷ lệ phân bổ (%)
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Số thuế phải nộp
              </Th>
            </tr>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Tỉnh</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Huyện</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Cơ quan thuế cấp Cục</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Cơ quan thuế quản lý</Th>
            </tr>
            <tr style={{ fontWeight: "bold", background: "#eaeae9"  }}>
              <Th style={{ fontWeight: "bold", textAlign: "center" }}>[04]</Th>
              <Th style={{ fontWeight: "bold", textAlign: "center" }}></Th>
              <Th style={{ fontWeight: "bold", textAlign: "center" }}>[05]</Th>
              <Th style={{ fontWeight: "bold", textAlign: "center" }}>[06]</Th>
              <Th style={{ fontWeight: "bold", textAlign: "center" }}>[08]</Th>
              <Th style={{ fontWeight: "bold", textAlign: "center" }}>[07]</Th>
              <Th style={{ fontWeight: "bold", textAlign: "center" }} colSpan="2">
                [09]
              </Th>
              <Th style={{ fontWeight: "bold", textAlign: "center" }}>[10]</Th>
              <Th style={{ fontWeight: "bold", textAlign: "center" }}>[11]</Th>
              <Th style={{ fontWeight: "bold", textAlign: "center" }}>[12]=[11]x[10]</Th>
            </tr>

            {data.factory.map((item, index) => (
              <tr key={index}>
                <Td className="toggle-button" style={{ textAlign: "right", background: "#ddeff3" }}>
                  1
                  <div className="button-action">
                    <button type="button" onClick={() => handleAdd("muc1")}>
                      Thêm dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ background: "#ddeff3" }}>{item.value2}</Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    type="text"
                    name="value3"
                    value={item.value3}
                    onChange={handleChange}
                    id={item.id}
                    rowType="factory"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    type="text"
                    name="value4"
                    value={item.value4}
                    onChange={handleChange}
                    id={item.id}
                    rowType="factory"
                  />
                </Td>
                <Td style={{ background: "#ddeff3"}}></Td>
                <Td style={{ background: "#ddeff3"}}></Td>
                <Td style={{ background: "#ddeff3"}}></Td>
                <Td style={{ background: "#ddeff3"}}></Td>
                <Td style={{ textAlign: "right", fontWeight: "bold" }}>
                  <InputTable
                    type="number"
                    name="value9"
                    value={item.value9}
                    onChange={handleChange}
                    id={item.id}
                    rowType="factory"
                  />
                </Td>
                <Td style={{ textAlign: "right", fontWeight: "bold", background: "#ddeff3" }}>
                  {item.value10}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    type="number"
                    name="value11"
                    value={item.value11}
                    onChange={handleChange}
                    id={item.id}
                    rowType="factory"
                  />
                </Td>
              </tr>
            ))}
            {data.muc1.map((item, index) => (
              <tr key={index}>
                <Td className="toggle-button" style={{ textAlign: "right", background: "#ddeff3" }}>
                  1.{index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc1", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "right", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc1", item.id, "value2", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}></Td>
                <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}></Td>
                <Td style={{ textAlign: "right", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc1", item.id, "value5", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "right", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc1", item.id, "value6", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "right", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc1", item.id, "value7", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "right", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc1", item.id, "value8", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "right", fontWeight: "bold", background: "#ddeff3" }}>
                  {item.value9}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    type="decimal"
                    name="value10"
                    value={item.value10}
                    onChange={handleChange}
                    id={item.id}
                    rowType="muc1"
                  />
                </Td>
                <Td style={{ textAlign: "right", fontWeight: "bold", background: "#ddeff3" }}>
                  {item.value11}
                </Td>
              </tr>
              
            ))}
             <tr>
                <Td colSpan="8"
                  row={{ bold: true }}
                  style={{
                    textAlign: "center",
                    background: "#ddeff3",
                  }}
                >
                  Tổng cộng:
                </Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    fontWeight: "bold",
                    background: "#ddeff3",
                  }}
                >
                  0
                </Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    fontWeight: "bold",
                    background: "#ddeff3",
                  }}
                >
                  0
                </Td>
              </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(Table2);

function InputTable(props) {
  const { onChange, type = "text", name, id, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (type === "text") {
      onChange({ value, name, type, id, rowType });
    } else if (type === "date") {
      onChange({ value, name, type, id, rowType });
    } else if (type == "decimal") {
      if (!regexDecimal.test(value)) return;
      onChange({ value, name, id, rowType });
    } else {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, type, id, rowType });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      name={name}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
